<div class="content-wrap">
	<div class="group-1">
		<!-- *ngIf="showZoomToRecord" -->
		<div class="map-icon" [ngClass]="{'disabled-icon': !showZoomToRecord}" title="Zoom to selected record">
			<mat-icon class="icon-general" svgIcon="icon-fullscreen-off" (click)="zoomToRecord()"></mat-icon>
		</div>
		<div class="zoom-in map-icon icon-general" title="Zoom in" (click)="zoomIn()">
			<i class="glyphicons glyphicons-zoom-in"></i>
		</div>
		<div class="zoom-in map-icon icon-general" title="Zoom out" (click)="zoomOut()">
			<i class="glyphicons glyphicons-zoom-out"></i>
		</div>
		
		<div class="layer-controls map-icon" title="Open layer control" (click)="toggleLayerControl()">
			<mat-icon class="icon-general" svgIcon="icon-layers"></mat-icon>
		</div>

		<div class="bookmark-manager map-icon icon-general" title="Open bookmark manager" (click)="openBookmark()">
			<i class="glyphicons glyphicons-bookmark"></i>
		</div>
	</div>

	<div class="group-bottom">
		<div class="map-legends map-icon" title="Map Legends" (mouseover)="onMouseoverMapLegend()" (mouseout)="onMouseoutMapLegend()">
			<mat-icon class="icon-general" svgIcon="icon-map-legend"></mat-icon>
		</div>
	</div>
	<!-- <div class="group-2">
		<div *ngIf="showRefLayerOpacitySlider" class="ref-layer-opacity">
			<label>Reference Layer Opacity:</label>
			<mat-slider #refLayerSlider class="layer-opacity-slider" min="0" max="1" step="0.1" tickInterval="2" [(ngModel)]="refLayerOpacity" (ngModelChange)="onRefSliderDragEnd();refLayerSlider.blur();">
			</mat-slider>
		</div>
		<div *ngIf="showBasemapOpacitySlider" class="ref-layer-opacity" title="Basemap Opacity">
			<mat-slider vertical #basemapSlider class="layer-opacity-slider" min="0" max="1" step="0.1" tickInterval="2" [(ngModel)]="basemapOpacity" (ngModelChange)="onBasemapSliderDragEnd();basemapSlider.blur();">
			</mat-slider>
		</div>
	</div> -->
</div>

<!-- <div *ngIf="showBdrySelection&&false" class="bdry-selection">
	<select name="layer-option" [(ngModel)]="selectedBdry" (ngModelChange)="onSelectBdry()">
		<option *ngFor="let bdry of bdryLayers" [ngValue]="bdry">{{bdry.label}}</option>
	</select>
</div> -->
